
import { Facets } from '@empathyco/x-components/facets'
import { defineComponent } from 'vue'

import Facet from './facet.component.vue'

export default defineComponent({
  name: 'XFacets',
  components: {
    Facets,
    Facet,
  },
  props: {
    messages: {
      type: Object,
      required: true,
    },
  },
  data(): Record<string, any> {
    return {
      baseClass: 'epb-x-facets',
    }
  },
})
